import React from 'react'

interface State {
  error: Error | null
}

// PROJECT_MEMORY §7 — wrap pages so a single render error doesn't blank the app.
export class PageErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null }
  static getDerivedStateFromError(error: Error): State {
    return { error }
  }
  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('PageErrorBoundary caught', error, info)
  }
  reset = () => this.setState({ error: null })
  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <h1>Etwas ist schiefgelaufen</h1>
          <pre>{this.state.error.message}</pre>
          <button type="button" className="btn btn-primary" onClick={this.reset}>
            Erneut versuchen
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
